// extracted by mini-css-extract-plugin
module.exports = {"axiom":"Axiom__axiom--zHIBv","text":"Axiom__text--qKg8X"};